<template>
  <b-sidebar
    id="sidebar-update-user"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Update') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="userUpdateValidation">
          <b-row>
            <b-col md="6">
              <b-form-group
                :label="$t('First name')"
                label-for="first_name"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('First name')"
                  rules="required"
                >
                  <b-form-input
                    id="first_name"
                    v-model="user.first_name"
                    :placeholder="$t('First name')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                :label="$t('Surname')"
                label-for="surname"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Surname')"
                  rules="required"
                >
                  <b-form-input
                    id="surname"
                    v-model="user.sur_name"
                    :placeholder="$t('Surname')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Middle name')"
                label-for="mid_name"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Middle name')"
                  rules="required"
                >
                  <b-form-input
                    id="mid_name"
                    v-model="user.mid_name"
                    :placeholder="$t('Middle name')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Birthday')"
                label-for="birth_date"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Birthday')"
                  rules="required"
                >
                  <flat-pickr
                    id="birth_date"
                    v-model="user.birth_date"
                    class="form-control"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Birth place')"
                label-for="birth_place"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Birth place')"
                  rules="required"
                >
                  <div class="form-label-group">
                    <b-form-input
                      id="birth_place"
                      v-model="user.birth_place"
                      :placeholder="$t('Birth place')"
                    />
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Citizenship')"
                label-for="citizenship"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Citizenship')"
                  rules="required"
                >
                  <div class="form-label-group">
                    <b-form-input
                      id="citizenship"
                      v-model="user.ctzn"
                      :placeholder="$t('Citizenship')"
                    />
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Gender')"
                label-for="gender"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Gender')"
                  rules="required"
                >
                  <b-form-select
                    id="gender"
                    v-model="user.gd"
                    :options="genders"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Nationality')"
                label-for="natn"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Nationality')"
                  rules="required"
                >
                  <div class="form-label-group">
                    <b-form-input
                      id="natn"
                      v-model="user.natn"
                      :placeholder="$t('Nationality')"
                    />
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Country')"
                label-for="country"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Country')"
                  rules="required"
                >
                  <div class="form-label-group">
                    <b-form-input
                      id="country"
                      v-model="user.country"
                      :placeholder="$t('Country')"
                    />
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Permanent address')"
                label-for="per_adr"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Permanent address')"
                  rules="required"
                >
                  <div class="form-label-group">
                    <b-form-input
                      id="per_adr"
                      v-model="user.per_adr"
                      :placeholder="$t('Permanent address')"
                    />
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Validity of the passport')"
                label-for="validity_of_the_passport"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Validity of the passport')"
                  rules="required"
                >
                  <flat-pickr
                    id="validity_of_the_passport"
                    v-model="user.pport_expr_date"
                    class="form-control"
                    :locale="$i18n.locale"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Date of passport issuance')"
                label-for="date_of_passport_issuance"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Date of passport issuance')"
                  rules="required"
                >
                  <flat-pickr
                    id="date_of_passport_issuance"
                    v-model="user.pport_issue_date"
                    class="form-control"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Who issued the passport')"
                label-for="Who_issued_the_passport"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Who issued the passport')"
                  rules="required"
                >
                  <b-form-input
                    id="Who_issued_the_passport"
                    v-model="user.pport_issue_place"
                    :placeholder="$t('Who issued the passport')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Passport series and number')"
                label-for="Passport_series_and_number"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Passport series and number')"
                  rules="required"
                >
                  <b-form-input
                    id="Passport_series_and_number"
                    v-model="user.pport_no"
                    :placeholder="$t('Passport series and number')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Mobile phone')"
                label-for="mob_phone_no"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Mobile phone')"
                  rules="required"
                >
                  <b-form-input
                    id="mob_phone_no"
                    v-model="user.mob_phone_no"
                    :placeholder="$t('Mobile phone')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Update') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BButton, BRow, BCol, BFormGroup, BFormInput, BFormSelect,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import { required, integer } from '@/libs/validations/validations'

export default {
  name: 'Update',
  components: {
    BSidebar,
    BForm,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
    }
  },
  computed: {
    user() {
      return { ...this.$store.state.user.user.data }
    },
    scientificDegrees() {
      return this.$store.state.staticModule.scientificDegrees
    },
    userTypes() {
      return this.$store.state.staticModule.userTypes
    },
    scientificTitles() {
      return this.$store.state.staticModule.scientificTitles
    },
    digitalSignature() {
      return [
        {
          value: true,
          text: this.$t('Yes'),
        },
        {
          value: false,
          text: this.$t('No'),
        },
      ]
    },
    genders() {
      return [
        {
          value: 1,
          text: this.$t('Male'),
        },
        {
          value: 2,
          text: this.$t('Female'),
        },
      ]
    },
  },
  created() {
    localize(this.$i18n.locale)
    this.$store.dispatch('staticModule/scientificTitle')
    this.$store.dispatch('staticModule/scientificDegree')
  },
  setup() {
    const MODULE_NAME = 'user'
    return {
      MODULE_NAME,
    }
  },
  methods: {
    clear(hide) {
      // this.$store.commit('quote/FRESH', this.$route.params.id)
      this.$refs.userUpdateValidation.reset()
      hide()
    },
    submit(hide) {
      this.$refs.userUpdateValidation.validate().then(success => {
        if (success) {
          this.$createSwal(this, this.user, 'user/updateForeignUser', () => {
            this.$emit('refetchData')
            this.clear(hide)
          })
          hide()
        }
      })
    },
  },
}
</script>

<style>
#sidebar-update-user {
  width: 50rem;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
